import { Recaptcha } from '../recaptcha';
import BaseRequest from '../baseRequest';

import { ICompletionsApiOptions, ICompletionsRequestOptions } from './types';

export class CompletionsApi extends BaseRequest {
  constructor(options: ICompletionsApiOptions) {
    const recaptcha = new Recaptcha(options.recaptchaToken);

    super({
      ...options,
      getRecaptchaToken: recaptcha.getToken.bind(recaptcha),
    });
  }

  /* Based on OpenAI completions API https://beta.openai.com/docs/api-reference/completions/create.
     The '/completions' endpoint proxies the request to OpenAI.

     IMPORTANT:
     The only difference from the openAI API is the 'filter' parameter. When this is 'true',
     the response 'choices' will have a 'filter' parameter which can be:
     'safe' | 'sensitive' | 'unsafe'.
  */
  public async getCompletions({
    model = 'text-davinci-002',
    prompt,
    temperature = 1,
    n = 3,
    max_tokens = 500,
    filter = true,
    user,
  }: ICompletionsRequestOptions) {
    const res = await this.post('/completions', {
      model,
      prompt,
      temperature,
      n,
      max_tokens,
      filter,
      user,
    });

    return res.data;
  }
}
